import manifest from "./season-manifest.json";

// All data comes from the season manifest owned by the exodia backend
// (Common.SeasonManifest, published as manifest.json with the aggregation
// output). Resync the local copy with `yarn sync-manifest`; never edit these
// tables by hand.
export const CLASSES_AND_SPECS = manifest.classes.map((c) => ({
  class: c.name,
  color: c.color,
  icon: c.icon,
  specs: c.specs.map((s) => ({ title: s.name })),
}));

export const CLASSES_FOR_URL = manifest.classes.map((c) => c.url);

// FIRST HERO NAME IS THE LEFT TREE AND SECOND IS THE RIGHT TREE MAPPED TO HOW THE TALENT TREES ARE.
export const SPECS_TO_HERO_TREES = Object.fromEntries(
  manifest.classes.map((c) => [c.name, { specs: Object.fromEntries(c.specs.map((s) => [s.name, s.hero_trees])) }]),
);
